import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ClosingCostsByCity from "@/pages/ClosingCostsByCity";

export const Route = createFileRoute("/closing-costs/city/$city")({
  head: ({ params }) => seoHead(`/closing-costs/city/${params.city}`),
  component: ClosingCostsByCity,
});
